import { fromHouseConsignmentDetailsResponse, toCreateHouseConsignmentRequest } from '../models/mapper'
import { HouseConsignmentCreate } from '../models/request'
import { HouseConsignmentDetails } from '../models/types'
import { createHouseConsignmentDraftV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createHouseConsignmentDraft(data: HouseConsignmentCreate): Promise<HouseConsignmentDetails> {
  const response = await createHouseConsignmentDraftV3(toCreateHouseConsignmentRequest(data))
  return fromHouseConsignmentDetailsResponse(response)
}
